import { makeStyles, Button } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { datesAreOnSameDay, prettyDate, to_YYYYMMDDHHMMSS} from '../../../config/dateFormatting';
import clsx from 'clsx';
import { IDishesBooked, ISeatingBookedMenus, ISeatingsBooked } from '../../../interface/interface';
import { IBookingContent, IDishContent, ISeatingContent, IUserContent, IVersionedObject } from '../../../planEatApi/PlanEatFacade';
import { useHistory } from 'react-router-dom';
import { FrontendApi } from '../../../planEatApi/FrontendApi';
import { OfficeContext } from '../../../config/Context';
import { planEatApi } from '../../../planEatApi/PlanEatApi';
import { DateCarousel } from '../../../components/ui/DateCarousel';
import { icon_bigCheckInIcon, icon_smallCheckInIcon } from '../../../assets/images/images';
import { Calendar, DateObject } from 'react-multi-date-picker';
import { MdAdd, MdDownload, MdOutlineArrowDropDownCircle } from 'react-icons/md';
import { AddBookingModal } from '../components/AddBookingModal';
import { useAdminDateQueryParam } from '../../../hooks/useAdminDateQueryParam';
import { IServiceUserInfo } from '../../../datasolvr/ServicesFacade';


const useStyles = makeStyles((theme: any) => ({
    dashboardTopOverviewRow:{
        display: 'grid',
        gridTemplateColumns: 'auto 30%',
        marginTop: 24,
        columnGap: 30
    },
    dashboardOverviewContainer:{
        width: '100%',
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        padding: 30,
    },
    dashboardTodayAndTotalRow:{
        display: 'grid',
        gridTemplateColumns: 'auto 200px',
        columnGap: 20
    },
    todaysMenuContainer:{
        paddingRight: 30
    },
    todaysMenuTotalBookingTitle:{
        fontSize: 20,
        fontWeight: 700
    },
    twoItemColumn:{
        display: 'grid',
        width: '100%',
        gridTemplateColumns: '100%',
        justifyItems: 'center',
    },
    totalBookingNumberTitle:{
        fontSize: 30,
        fontWeight: 700 
    },
    totalBookingNumberTitleSmall:{
        fontSize: 24,
        fontWeight: 700,
        lineHeight: '1.1',
    },
    totalBookingNumberText:{
        fontSize: 11,
        fontWeight: 400 
    },
    bigCheckInContainer:{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: 103,
        borderRadius: 6,
        fontSize: 18
    },
    bigCheckInIcon:{
        heigt:30,
        width: 30,
        marginRight: 10,
    },
    totalBookingGrid:{
        display: 'inline-grid',
        gridTemplateColumns: '100% 100%',
        maxHeight: 230,
        rowGap: 20,
        width: 100, 
    },
    spanTwoRows:{
        gridColumn: '1 / 3',
    },
    hrRight:{
        borderRight: '1px dashed rgba(11, 37, 89, 0.2);'
    },
    hrBottom:{
        borderBottom: '1px dashed rgba(11, 37, 89, 0.2);'
    },
    dishBookedContainer:{
        display: 'grid',
        gridTemplateColumns: '40px auto 130px',
        justifySelf: 'center',
        alignItems: 'center',
        padding: 5
    },
    dishBookedIndex:{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '2px solid #6178ED',
        borderRadius: '50%',
        fontSize: 18,
        fontWeight: 700,
        color: '#6178ED',
        height: 30,
        width: 30,
    },
    dishBookedTitle:{
        paddingLeft: 16,
        fontSize: 16,
        fontWeight: 400,
        color: '#374251'
    },
    dishBookedNumbersContainer:{
        paddingLeft: 10,
        display:'grid',
        gridTemplateColumns: '50% 50%',
        width: '100%'
    },
    seatingsBookedContainer:{
        cursor: 'pointer',
        display:'grid',
        gridTemplateColumns: '80% 20%',
        width: '100%',
        padding: 9,
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        background: '#FFFFFF',
    },
    seatingBookedCheckInIcon:{
        width: 17,
        height: 17,
        color: '#6178ED',
        paddingRight: 5
    },
    seatingBookedCheckInText:{
        display: 'flex',
        justifyContent: 'start',
        alignItems: 'center',
        fontSize: 10,
        fontWeight: 400,
        color: theme.palette.primary.main,
        marginTop: 10
    },
    seatingsBookedSeatingTime:{
        fontSize: 22,
        fontWeight: 400,
    },
    seatingsBookedSeatingName:{
        fontSize: 12,
        fontWeight: 700
    },
    timesOptionContainer:{
        marginTop: 50
    },
    timesOptionRowContainer:{
        display: 'grid',
        gridTemplateColumns: '30% 70%',
        width: '100%'
    },
    timesOptionRowContent:{
        display:'flex',
        justifyContent:'flex-end',
        "& > *": {
            marginLeft: 30
        }
    },
    timesOptionRowTitleContainer:{
        display:'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        float:'left'
    },
    timesOptionHeader: {
        fontSize: 16,
        fontWeight: 700
    },
    timesOptionMenuDescription:{
        fontSize: 8,
        fontWeight: 400
    },
    timesOptionMenuItemContainer:{
        display: 'grid',
        gridTemplateColumns: '100%',
        justifyItems: 'center',
        float: 'left',
        width: 120
    },
    timesOptionEstimateContainer:{
        display: 'flex',
        justifyContent: 'center',
        float: 'left',
        width: 120,
        padding: 12
    },
    timesOptionSeatingTime:{
        fontSize: 12,
        fontWeight: 700
    },
    timesOptionSeatingName:{
        paddingLeft: 5,
        fontSize: 12,
        fontWeight: 400
    },
    timesOptionBookedEstimatContainer:{
        fontSize: 12,
        fontWeight: 700,
    },
    timesOptionBookedEstFlex:{
        display: 'flex',
        float: 'left',
        paddingLeft: 5
    }, 
    noItemsOnDateContainer:{
        display: 'flex',
        justifyContent: 'center',
        alignItems:'center',
        height: '100%',
        width:'100%',
        fontWeight: 700,
        fontSize: 14,
        color: '#AAAAAA',
    },
    totalHeader: {
        fontSize: 16,
        fontWeight: 700,
        marginTop: 20,
        paddingBottom: 20
    },
    estimateColor: {
        color: theme.palette.primary.main,
        opacity: 0.5
    },
    calendarContainer: {
        padding: 15,
        background: 'white',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8
    },
    seatingContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 15,
        width: "100%",
    },
    fullBreakDownButton: {
        color: theme.palette.primary.main,
        width: '100%',

        "& > span":{
            display: 'flex',
            flexDirection: 'row',
            columnGap: 10,
            textTransform: 'none',
            fontSize: 18
        }
    },
    topRowContainer: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%"
    },
    addDownloadContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    downloadTodaysBookingButton:{
        display: "flex",
        columnGap: 10,
        color: theme.palette.primary.main,
    }
}));

export const AdminDashboard: React.FC = () => {
    // Styling
    const classes = useStyles();

    // Routing
    let history = useHistory();
    
    // State
    const [date, setDate] = useState<Date>(new Date);
    const [dishesOnDate, setDishesOnDate] = useState<IVersionedObject<IDishContent>[]>([]);

    const [dishesBooked, setDishesBooked] = useState<IDishesBooked[]>([]);
    const [dishesBookedView, setDishesBookedView] = useState<any[]>([]);

    const [seatingsOnDate, setSeatingsOnDate] = useState<IVersionedObject<ISeatingContent>[]>([]);
    const [seatingBookedMenus, setSeatingBookedMenus] = useState<ISeatingBookedMenus[]>([]);
    const [seatingsBookedOneDateView, setSeatingsBookedOnDateView] = useState<any[]>([]);
    const [seatingsBookedOnDate, setSeatingsBookedOnDate] = useState<ISeatingsBooked[]>([]);

    const [totalBooked, setTotalBooked] = useState(0);
    const [totalEstimated, setTotalEsitimated] = useState(0);
    const [timeOptionView, setTimeOptionView] = useState<any[]>([]);

    const [showFullBreakdown, setShowFullBreakdown] = useState(false)
    const [isAddBookingHidden, setIsAddBookingHidden] = useState(true)

    // Entities 
    const officeContext = useContext(OfficeContext);
    const [seatings,setSeatings] = useState<IVersionedObject<ISeatingContent>[]>([]);
    const [bookings,setBookings] = useState<IVersionedObject<IBookingContent>[]>([]);
    const [dishes,setDishes] = useState<IVersionedObject<IDishContent>[]>([]);
    const [users, setUsers] = useState<IVersionedObject<IUserContent>[]>([]);
    const [serviceUsers, setServiceUsers] = useState<IServiceUserInfo[]>([])
    
    /* Get required info */
    async function getDatabase(){
        if(officeContext?.office){
            planEatApi.getSeatings().then((response) => setSeatings(response.data.filter(seating => seating.content.officeId === officeContext?.office?.content.id))).catch((e) => console.log(e))
            planEatApi.getBookings().then((response) => {setBookings(response.data)}).catch((e) => {console.log(e)})
            planEatApi.getDishes().then((response) => {setDishes(response.data)}).catch((e) => {console.log(e)})
            planEatApi.getUsers().then((response) => {setUsers(response.data)}).catch((e) => {console.log(e)})
            planEatApi.getServiceUsers().then((response) => {setServiceUsers(response.data)}).catch((e) => {console.log(e)})
        }
    }

    /* Update local date if global different than today */
    useAdminDateQueryParam(date,setDate)
    
    useEffect(() => {
        getDatabase()
    },[officeContext?.office])

    useEffect(() => {
        if(officeContext?.office){
            getSeatingsBookedOnDate();
            getDisplayTimeOption(officeContext?.office.content.id);
        }
    }, [date,seatings,bookings,dishes]);

    const getSeatingsBookedOnDate = () => {
        FrontendApi.getSeatingsBookedOnDate(date,seatings,bookings)
        .then(response => {
            setSeatingsBookedOnDate(response)
        })
    }
    useEffect(() => {
        displaySeatingsBooked();
    }, [seatingsBookedOnDate]);

    useEffect(() => {
        displayDishesBooked();
        calculateTotal();
    }, [dishesBooked]);

    const calculateTotal = () => {
        var tmpTotalBooked = 0;
        var tmpTotalEstimated = 0;

        dishesBooked.forEach((dishBooked) => {
            tmpTotalBooked += dishBooked.booked
            tmpTotalEstimated += dishBooked.estimated;
        }) 
        setTotalBooked(tmpTotalBooked);
        setTotalEsitimated(tmpTotalEstimated);
    }

    useEffect(() => {
        isTodayWeekend()
    },[date])

    function isTodayWeekend(){
        const today = new Date()
        if(datesAreOnSameDay(date,today)){
            if(today.getDay() === 0){
                setDate(new Date(today.setDate(today.getDate() + 1)))
            } else if (today.getDay() === 6){
                setDate(new Date(today.setDate(today.getDate() + 2)))
            }
        }
    }

    function getDisplayTimeOption (officeId: string){
        FrontendApi.getSeatingsOnDate(date,officeId,seatings)
        .then(tmpSeatingOnDate => {
            setSeatingsOnDate(tmpSeatingOnDate)
            FrontendApi.getDishesOnDate(date,tmpSeatingOnDate,dishes,bookings)
            .then(tmpDishesOnDate => {
                setDishesOnDate(tmpDishesOnDate);

                FrontendApi.getSeatingBookedMenus(tmpDishesOnDate,tmpSeatingOnDate,bookings)
                .then(tmpSeatingsBookedMenus => {
                    setSeatingBookedMenus(tmpSeatingsBookedMenus)
                    displayTimeOption(tmpSeatingsBookedMenus,tmpDishesOnDate)
                })

                FrontendApi.getDishesBooked(tmpDishesOnDate,officeId,bookings,tmpSeatingOnDate)
                .then(tmpDishesBooked => {
                    setDishesBooked(tmpDishesBooked)
                    displayDishesBooked()
                })
            })
        })
    }

    const displayDishesBooked = () => {
        if(dishesBooked.length > 0){
            const tmpDishesBookedView = dishesBooked.map((dishBooked,index) => (
                <div className={clsx(classes.dishBookedContainer,classes.hrBottom)} >
                    <div className={classes.dishBookedIndex}>
                        {index + 1}
                    </div>
                    <div className={classes.dishBookedTitle}>
                        {dishBooked.dishTitle}
                    </div>
                    <div className={classes.dishBookedNumbersContainer}>
                        <div className={classes.twoItemColumn}>
                            <div className={classes.totalBookingNumberTitleSmall}>
                                {dishBooked.booked}
                            </div>
                            <div className={classes.totalBookingNumberText}>
                                Booked
                            </div>
                        </div>
                        <div className={classes.twoItemColumn}>
                            <div className={clsx(classes.totalBookingNumberTitleSmall,classes.estimateColor)}>
                                {dishBooked.estimated}
                            </div>
                            <div className={clsx(classes.totalBookingNumberText,classes.estimateColor)}>
                                Estimated
                            </div>
                        </div>
                    </div>
                </div>
            ));
            setDishesBookedView(tmpDishesBookedView);
        } else{
            const tmpNoDishesBookedOnDate : any =  (
                <div className={classes.noItemsOnDateContainer}>
                    No dishes on date 
                </div>
            );
            setDishesBookedView(tmpNoDishesBookedOnDate)
        }
    }
    
    const displaySeatingsBooked = () => {
        if(seatingsBookedOnDate.length > 0){
            const tmpSeatingsBookedView = seatingsBookedOnDate.map((seatingBooked,index) => (
                <div className={classes.seatingsBookedContainer} onClick={() => history.push({pathname:'/admin/checkIn',search: "" + history.location.search + '&seatingId='+ seatingBooked.seatingId})}>
                    <div>
                        <div className={classes.seatingsBookedSeatingTime}>
                            {seatingBooked.seatingTime}
                        </div>
                        <div className={classes.seatingsBookedSeatingName}>
                            {seatingBooked.seatingName}
                        </div>
                        <div className={classes.seatingBookedCheckInText}>
                            <img src={icon_smallCheckInIcon} alt="smallCheckInIcon" className={classes.seatingBookedCheckInIcon}/>Check-In
                        </div>
                    </div>
                    <div>
                        <div className={classes.twoItemColumn}>
                            <div className={classes.totalBookingNumberTitleSmall}>
                                {seatingBooked.booked}
                            </div>
                            <div className={classes.totalBookingNumberText}>
                                Booked
                            </div>
                        </div>
                        <div className={classes.twoItemColumn}>
                            <div className={clsx(classes.totalBookingNumberTitleSmall,classes.estimateColor)}>
                                {seatingBooked.estimated}
                            </div>
                            <div className={clsx(classes.totalBookingNumberText,classes.estimateColor)}>
                                Estimated
                            </div>
                        </div>
                    </div>
                </div>
            ));
            setSeatingsBookedOnDateView(tmpSeatingsBookedView);
        } else {
            const tmpNoSeatingsOnDate : any =  (
                <div className={classes.noItemsOnDateContainer}>
                   
                </div>
            );
            setSeatingsBookedOnDateView(tmpNoSeatingsOnDate)
        }
    }

    const calculateSeatingTotal = (tmpSeatingsBookedMenus: ISeatingBookedMenus[], dishOnDate: IVersionedObject<IDishContent>) => {
        var totalBooked = 0;
        var totalEstimate = 0;

        tmpSeatingsBookedMenus.forEach((seatingBookedMenu) => {
            seatingBookedMenu.bookedDishes.forEach((bookedDish) => {
                if (bookedDish.dishId === dishOnDate.content.id) {
                    totalBooked += bookedDish.booked;
                    totalEstimate += bookedDish.estimated;
                }
            })
        })
        return [totalBooked, totalEstimate]
    }

    
    const displayTimeOption = (tmpSeatingsBookedMenus: ISeatingBookedMenus[],dishesOnDate : IVersionedObject<IDishContent>[]) => {
        if(tmpSeatingsBookedMenus.length > 0){
            let tmpDisplayOptionTime : any[] = []

            const tmpOptionTimeHeader : any =  (
                <div className={classes.timesOptionRowContainer}>
                    <div className={classes.timesOptionHeader}>
                        Times / Option
                    </div>
                    <div className={classes.timesOptionRowContent}>
                        { dishesOnDate.map((dishOnDate,index) => (
                            <div className={classes.timesOptionMenuItemContainer}>
                                <div className={classes.timesOptionHeader}>
                                    Menu {index + 1}
                                </div>
                                <div className={classes.timesOptionMenuDescription}>
                                    {dishOnDate.content.dishDescription}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            );
            tmpDisplayOptionTime.push(tmpOptionTimeHeader)

            const tmpTimesOptionContent = tmpSeatingsBookedMenus.map((seatingBookedMenu,index) => (
                <div className={clsx(classes.timesOptionRowContainer,classes.hrBottom)}>
                    <div className={classes.timesOptionRowTitleContainer}>
                        <div className={classes.timesOptionSeatingTime}>
                            {prettyDate(seatingBookedMenu.seatingTime,true,false)}
                        </div>
                        <div className={classes.timesOptionSeatingName}>
                            {seatingBookedMenu.seatingName}
                        </div>
                    </div>
                    <div className={classes.timesOptionRowContent}>
                        { dishesOnDate.map((dishOnDate,index2) => (
                            <div className={classes.timesOptionBookedEstimatContainer}>
                                {seatingBookedMenu.bookedDishes[index2] 
                                
                                ? 
                                <div className={classes.timesOptionEstimateContainer}>
                                    <div className={classes.timesOptionBookedEstFlex}>
                                        {seatingBookedMenu.bookedDishes[index2].booked}
                                    </div>
                                    <div className={clsx(classes.timesOptionBookedEstFlex,classes.estimateColor)}> 
                                        / {seatingBookedMenu.bookedDishes[index2].estimated}
                                    </div> 
                                </div>
                                :
                                <div className={classes.timesOptionEstimateContainer}></div>
                            }
                            </div>     
                        ))}
                    </div>
                </div>
            ));
            tmpDisplayOptionTime.push(tmpTimesOptionContent)
            let tmpTotalDisplay: any[] = [];
            tmpTotalDisplay.push(   
                <div className={classes.timesOptionRowContainer}>
                    <div className={classes.totalHeader}>
                        Total
                    </div>
                    <div className={classes.timesOptionRowContent}>
                        {dishesOnDate.map((dishOnDate, index) => (
                            <div className={classes.timesOptionEstimateContainer}>
                                <div className={classes.timesOptionBookedEstFlex} style={{fontSize:18,fontWeight:700}}>
                                    {calculateSeatingTotal(tmpSeatingsBookedMenus,dishOnDate)[0]}
                                </div>
                                <div className={clsx(classes.timesOptionBookedEstFlex,classes.estimateColor)} style={{fontSize:18,fontWeight:700}}>
                                    &nbsp;  / {calculateSeatingTotal(tmpSeatingsBookedMenus,dishOnDate)[1]}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )
            tmpDisplayOptionTime.push(tmpTotalDisplay)
            setTimeOptionView(tmpDisplayOptionTime)
        } else {
            const tmpNoSeatingsOnDate : any =  ([]);
            setTimeOptionView(tmpNoSeatingsOnDate)
        }
    }

    const toDate = (dateObject: DateObject) : Date => {
        return dateObject.toDate()
    }

    function handleCalendarDateChange(e: any) {
        if(e instanceof DateObject){
            setDate(toDate(e));
        }
    }

    function getBookingsOnOfficeOnDate(){
        if(officeContext?.office && date){
            planEatApi.getBookingsOnOfficeOnDate(officeContext.office.content.id,to_YYYYMMDDHHMMSS(date))
            .then((response) =>{
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                var officeName = officeContext?.office ? officeContext?.office.content.officeName : ""
                link.setAttribute('download', "Bookings from the " + prettyDate(date,false,true) + ".csv"); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
            .catch((e) => {
                console.log(e)
            })
        }
    }

    useEffect(() => {
        if(isAddBookingHidden){
            getDatabase()
        }
    },[isAddBookingHidden])

    function addBookingDiabled(){
        let today = new Date()
        date.setHours(12)
        date.setMinutes(0)
        date.setSeconds(0)
        return date.getTime() <= today.getTime()
    }

    return (
        <div>
            <div className={classes.topRowContainer}>
                <DateCarousel date={date} setDate={setDate}/>
                <div className={classes.addDownloadContainer}>
                    <Button className={classes.downloadTodaysBookingButton} variant="text" onClick={() => {setIsAddBookingHidden(false)}} disabled={addBookingDiabled()}>
                        <MdAdd color="primary" size={24} /> Add bookings 
                    </Button>
                    <Button className={classes.downloadTodaysBookingButton} variant="text" onClick={() => {getBookingsOnOfficeOnDate()}}>
                        <MdDownload color="primary" size={24} /> Download bookings
                    </Button>
                </div>
            </div>
            <div className={classes.dashboardTopOverviewRow}>
                <div className={classes.dashboardOverviewContainer}>
                    <div className={classes.dashboardTodayAndTotalRow}>
                        <div className={clsx(classes.todaysMenuContainer,classes.hrRight)}>
                            <div className={classes.todaysMenuTotalBookingTitle}>
                                Today's Menu
                            </div>
                            {dishesBookedView}
                        </div>
                        <div className={classes.totalBookingGrid}>
                            <div className={classes.spanTwoRows}>
                                <div className={classes.todaysMenuTotalBookingTitle}>
                                    Total Bookings
                                </div>
                            </div>
                            <div className={clsx(classes.twoItemColumn,classes.hrRight)}>
                                <div className={classes.totalBookingNumberTitle}>
                                    {totalBooked}
                                </div>
                                <div className={classes.totalBookingNumberText}>
                                    Booked
                                </div>
                            </div>
                            <div className={classes.twoItemColumn}>
                                <div className={clsx(classes.totalBookingNumberTitle,classes.estimateColor)}>
                                    {totalEstimated}
                                </div>
                                <div className={clsx(classes.totalBookingNumberText,classes.estimateColor)}>
                                    Estimated
                                </div>
                            </div>
                            <div className={clsx(classes.spanTwoRows,classes.hrBottom)} />
                            <div className={classes.spanTwoRows}>
                                <Button className={classes.fullBreakDownButton} variant="text" onClick={() => {setShowFullBreakdown(!showFullBreakdown)}} disabled={timeOptionView.length == 0}>
                                    Full Breakdown <MdOutlineArrowDropDownCircle color="primary" size={24}/>
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className={classes.timesOptionContainer}>
                        {
                            showFullBreakdown && timeOptionView
                        }
                    </div>
                </div>
                <div>
                    <div className={classes.calendarContainer}> 
                        <Calendar
                            currentDate={new DateObject()}
                            multiple={false}
                            value={date} 
                            onChange={handleCalendarDateChange}
                            weekStartDayIndex={1}
                            showOtherDays={false}
                            mapDays={({ date }) => {
                                // Styling of today
                                if(datesAreOnSameDay(date.toDate(), new DateObject().toDate())){
                                    return {
                                        style: { background: "#6178ed7c", color:'white' },
                                        id: "today-calendar-date",
                                        className: "calendar-date",
                                    }
                                }
                                
                                // Styling of weekends
                                let isWeekend = [0, 6].includes(date.weekDay.index)
                                if (isWeekend) return {
                                    disabled: true,
                                    style: { color: "#ccc" },
                                    className: "calendar-date",
                                    onClick: () => alert("Weekends are disabled")
                                }

                                // Identifiers for date spans
                                return{
                                    className: "calendar-date",
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className={classes.dashboardTopOverviewRow}>
                <div className={classes.seatingContainer}>
                    {seatingsBookedOneDateView}
                </div>
                <div>
                    <Button className={classes.bigCheckInContainer} onClick={() => history.push('/admin/checkIn')} variant='contained'>
                        <img src={icon_bigCheckInIcon} alt="bigCheckInIcon" className={classes.bigCheckInIcon}/>Check-In
                    </Button>
                </div>
            </div>
            <AddBookingModal
                hidden={isAddBookingHidden}
                setHidden={setIsAddBookingHidden}
                date={date} 
                seatingsOnDate={seatingsOnDate}
                users={users}
                serviceUsers={serviceUsers} />
        </div>
    );
}